import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { genericRequiredFieldError } from '../../constants';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: { primaryContactPhoneNumber },
} = loanFormModel;

export class PrimaryContactPhoneNumberValidation implements ValidationSchema {
  public name: string = primaryContactPhoneNumber.name;
  public label: string = primaryContactPhoneNumber.label;
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: genericRequiredFieldError,
    value: primaryContactPhoneNumber.required,
  };
  public nullable = true;
  public min = {
    value: 10,
    message: 'Must be 10 digits',
  };
  public max = {
    value: 10,
    message: 'Must be 10 digits',
  };
  public matches = {
    value: /^[0-9]+$/,
    message:
      'Please enter numbers only (no letters, spaces, or special characters)',
  };
}
export default new Validation(new PrimaryContactPhoneNumberValidation());
